import { render } from "./DonorAcceptabilitySectionDetails.vue?vue&type=template&id=9ecd666e&scoped=true"
import script from "./DonorAcceptabilitySectionDetails.vue?vue&type=script&lang=js"
export * from "./DonorAcceptabilitySectionDetails.vue?vue&type=script&lang=js"

import "./DonorAcceptabilitySectionDetails.vue?vue&type=style&index=0&id=9ecd666e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecd666e"],['__file',"src/components/DonorAcceptabilitySectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ecd666e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ecd666e', __exports__)) {
    api.reload('9ecd666e', __exports__)
  }
  
  module.hot.accept("./DonorAcceptabilitySectionDetails.vue?vue&type=template&id=9ecd666e&scoped=true", () => {
    api.rerender('9ecd666e', render)
  })

}


export default __exports__